import type { Table } from "dexie";
import { BaseDexieRepository } from "./base-repository";

/**
 * A push-to-talk recording that couldn't be transcribed during the hold
 * (offline, or the live stream died). Survives restarts; deleted once the
 * deferred transcription resolves and the message is sent.
 */
export type FloatingAgentPendingVoiceRecord = {
  id: string;
  blob: Blob;
  mimeType: string;
  createdAtIso: string;
  /** Lifetime transcription failures, persisted so retries survive restarts. */
  failedAttempts?: number;
};

export class FloatingAgentPendingVoiceRepository extends BaseDexieRepository<
  FloatingAgentPendingVoiceRecord,
  string
> {
  constructor(table: Table<FloatingAgentPendingVoiceRecord, string>) {
    super({ tableRef: () => table });
  }

  async add(record: FloatingAgentPendingVoiceRecord): Promise<void> {
    await this.table.put(record);
  }

  async listOldestFirst(): Promise<FloatingAgentPendingVoiceRecord[]> {
    const rows = await this.table.toArray();
    return rows.sort((a, b) => a.createdAtIso.localeCompare(b.createdAtIso));
  }

  async remove(id: string): Promise<void> {
    await this.table.delete(id);
  }

  async setFailedAttempts(id: string, failedAttempts: number): Promise<void> {
    await this.table.update(id, { failedAttempts });
  }
}
